import {Injectable} from '@angular/core';
import * as moment_ from 'moment';
import {Moment} from 'moment';
import * as moment from 'moment';


@Injectable({
    providedIn: 'root'
})
export class RcTimeService {

    public defaultViewDateFormat: string;
    public defaultServerDateFormat: string;
    public defaultServerDateTimeFormat: string;
    public fullDateTimeFormat: string;
    protected momentRef = moment_;

    constructor() {
        this.defaultViewDateFormat = 'DD/MM/YYYY';
        this.defaultServerDateFormat = 'YYYY-MM-DD';
        this.defaultServerDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
        this.fullDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
    }


  /**
   * get moment object
   * @param dateString - string of date e.g. '2011-02-15'
   * @param dateFormat - format of date e.g. 'YYYY-MM-DD'
   */
  moment(dateString: string | number = null, dateFormat: string = null): Moment {
      if (dateString === null) {
        return this.momentRef();
      } else {
        return this.momentRef(dateString, dateFormat);
      }
    }

    /**
     * Format a date
     * @param date
     * @param from
     * @param to
     * @returns string
     */
    format(date, from = this.defaultViewDateFormat, to = this.defaultServerDateFormat): string {
        if (this.momentRef(date, from).isValid()) {
            return this.momentRef(date, from).format(to);
        } else {
            return null;
        }
    }

    /**
     * @param date
     * @param toFormat
     * @returns string
     */
    formatFromJsDate(date: Date, toFormat: string = this.defaultServerDateFormat): string {
        return this.momentRef(date).format(toFormat);
    }

    /**
     * Format a date given a day month and a year
     * @param day
     * @param month
     * @param year
     * @param to
     * @returns string
     */
    formatFromDayMonthYear(day: number, month: number, year: number, to = this.fullDateTimeFormat): string {
        if (this.momentRef([year, month - 1, day]).isValid()) {
            return this.momentRef([year, month - 1, day]).format(to);
        } else {
            return null;
        }
    }

    /**
     * Get year from a date
     * @param date - any format supported by moment
     * @returns number
     */
    getYear(date) {
        return this.momentRef(date).get('year');
    }

    /**
     * Get month from a date
     * @param date
     * @returns number
     */
    getMonth(date) {
        return this.momentRef(date).get('month') + 1;
    }

    /**
     * Get day from a date
     * @param date
     * @returns number
     */
    getDay(date) {
        return this.momentRef(date).get('date');
    }

    /**
     * @param day
     * @param month
     * @param year
     * @returns moment.Moment
     */
    getTimeFromDayMonthYear(day: number, month: number, year: number) {
        return this.momentRef([year, month - 1, day]);
    }

    /**
     * @param date
     * @returns moment.Moment
     */
    getTimeFromString(date: string) {
        return this.momentRef(date);
    }

    /**
     * @param date1
     * @param date2
     * @returns number
     */
    getDiffInYears(date1, date2) {
        return this.momentRef.duration(date1.diff(date2)).asYears();
    }

  /**
   *
   * @param date1 - use moment function with params for a specific date
   * @param date2 - use moment function with params for a specific date
   * @param diffParam - 'years', 'month', 'days', 'min', 'sec'
   * @param precise - round diff or not (by default true, does not round)
   */
    getDiffBetweenTwoDates(date1: Moment, date2: Moment, diffParam: any = 'years', precise: boolean = true): number {
      return date1.diff(date2, diffParam, precise);
    }

    /**
     * @param format
     * @returns moment date
     */
    getCurrentDateTime(format: string = this.defaultServerDateTimeFormat): string {
        return this.momentRef().format(format);
    }

    /**
     * @param dateString YYYY-MM-DD HH:mm:ss
     * @returns moment obj of the date time
     */
    getMomentObjByDateString(dateString: string): moment_.Moment {
        return this.momentRef(dateString);
    }
}

